import { EMlSearchSessionGuidActionTypes } from '../../actions/mlSearchSessionGuid';
import { IAppState, TActions } from '../../common/state';

export function mlSearchSessionGuidReducer(state: IAppState, action: TActions): IAppState {
  switch (action.type) {
    case EMlSearchSessionGuidActionTypes.Set: {
      return {
        ...state,
        mlSearchSessionGuid: action.payload,
      };
    }
    default:
      return state;
  }
}
